import React, { memo, useEffect, useRef, useState } from 'react'
import tw from 'twin.macro'
import { TableLabel } from './TableLabel'
import { Tooltip } from '@mui/material'
import { colors } from 'src/theme'
import { addS } from 'src/utils/baseUtils'

const APPROX_LABEL_WIDTH = 80

interface Props {
  labels: string[]
  moreLabel?: string
}

const TableLabelsComponent = ({ labels, moreLabel }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [maxVisible, setMaxVisible] = useState<number>(labels.length)

  const visibleLabels = labels.slice(0, maxVisible)
  const hiddenLabels = labels.slice(maxVisible)
  const hiddenCount = hiddenLabels.length

  useEffect(() => {
    const container = containerRef.current

    if (!container) {
      return
    }

    const updateVisibleCount = () => {
      const containerWidth = container.clientWidth

      const visibleCount = Math.floor(containerWidth / APPROX_LABEL_WIDTH)
      setMaxVisible(Math.max(visibleCount, 1))
    }

    updateVisibleCount()

    window.addEventListener('resize', updateVisibleCount)

    return () => {
      window.removeEventListener('resize', updateVisibleCount)
    }
  }, [labels])

  return (
    <div ref={containerRef} css={tw`flex flex-wrap gap-1`}>
      {visibleLabels.map((item) => (
        <TableLabel key={item} label={item} />
      ))}
      {hiddenCount > 0 && moreLabel && (
        <Tooltip title={hiddenLabels.join(', ')} arrow>
          <span>
            <TableLabel
              textColor={colors.COLORS_BLUE_500}
              label={`+${hiddenCount} ${addS(hiddenCount, moreLabel)}`}
              className={tw`bg-[#D8E5FF]`}
            />
          </span>
        </Tooltip>
      )}
    </div>
  )
}

export const TableLabels = memo(TableLabelsComponent)
